import { z } from 'my-zod'
import { announcementSystemView } from './announcement-system-view'

export const announcementOutfitterView = announcementSystemView.omit({
  creatorName: true,
  createdDate: true,
  lastModifiedDate: true,
  creatorProfileId: true,
  description: true,
  lifecycleStatus: true,
  startDate: true,
  endDate: true,
  outfitterIds: true,
  regions: true,
  productLines: true,
  roles: true,
  featureFlags: true,
  removedDate: true
})

export type announcementOutfitterView = z.infer<typeof announcementOutfitterView>
